import "./style.css"; // Custom styles

import "./hear";
import "./there";

console.log("hear/there");
